import styled, { keyframes, css } from "styled-components";

export const LoadingDiv = styled.div`
  position: relative;
  width: 375px;
  height: 667px;
  margin: auto;
  overflow: hidden;
`;

const orangeX = keyframes`
    0% {
      left: 80px;
      animation-timing-function: ease-out;
    }
    25% {
      left: 120px;
      animation-timing-function: ease-in;
    }
    50% {
      left: 80px;
      animation-timing-function: ease-out;
    }
    75% {
      left: 40px;
      animation-timing-function: ease-in;
    }
    100% {
      left: 80px;
    
  }`;
const orangeY = keyframes`
    0% {
      top: 536px;
      animation-timing-function: ease-in;
    }
    25% {
      top: 577px;
      animation-timing-function: ease-out;
    }
    50% {
      top: 618px;
      animation-timing-function: ease-in;
    }
    75% {
      top: 577px;
      animation-timing-function: ease-out;
    }
    100% {
      top: 536px;
    }
  `;
const orangeAnim = css`
  ${orangeX} 5s infinite, ${orangeY} 5s infinite;
`;
const stopO = keyframes`
    to{
        top: 292px;
        left: 0px;
        color: rgba(255, 255, 255, 1);

    }
`;
const orangeStop = css`
  ${stopO} 1s 1 forwards;
`;
const isShakingOrangeAnim = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        transform:scale(1);
        top: 292px;
        left: 0px;
        color: rgba(255, 255, 255, 1);

      }
      
      50% { 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        transform:scale(.93);
        top: 292px;
        left: 0px;
        color: rgba(255, 255, 255, 1);

      }
      
      100%{ 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        transform:scale(1);
        top: 292px;
        left: 0px;
        color: rgba(255, 255, 255, 1);

      }
  `;
const isShakingOrange = css`
  ${isShakingOrangeAnim} 2s infinite forwards;
`;
const choosenPurpleAnimOrange = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        top: 292px;
        left: 0px;
         }
       100%{ 
        left: -310px;
        top: 0px;
        }
  `;
const choosenPurpleOrange = css`
  ${choosenPurpleAnimOrange} 983ms 1 forwards;
`;
const choosenYellowAnimOrange = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        top: 292px;
        left: 0px;
         }
       100%{ 
        left: -310px;
        top: 402px;
        }
  `;
const choosenYellowOrange = css`
  ${choosenYellowAnimOrange} 983ms 1 forwards;
`;
const choosenOrangeAnimOrange = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        top: 292px;
        left: 0px;
        transform: scale(1);
        /* color: rgba(255, 255, 255, 1); */
        opacity: 1;
      }
      50% { 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        left: 80px;
        top: 222px;
        opacity: 1;
        transform: scale(1);
        /* color: rgba(255, 255, 255, 1); */

      }
      100%{ 
        left: 80px;
        top: 222px;
        transform: scale(9);
        opacity: 0;
        /* color: rgba(255, 255, 255, 0); */

       }
  `;
const choosenOrangeOrange = css`
  ${choosenOrangeAnimOrange} 2500ms 1 forwards;
`;
export const Orange = styled.div`
  position: absolute;
  width: 210px;
  height: 210px;
  text-align: center;
  line-height: 210px;
  color: rgba(255, 255, 255, 0);

  top: ${(p) => (p.c.ot ? p.c.ot + "px" : "518px")};
  left: ${(p) => (p.c.ol ? p.c.ol + "px" : "86px")};
  border-radius: 110px;
  box-shadow: inset 0 0.5px 20px 0 #ff3920;
  pointer-events: ${(p) => (p.isLoaded ? "auto" : "none")};

  background-image: radial-gradient(
    circle at 63% 43%,
    #ffb000,
    #ff5e16 81%,
    #ff3920 130%
  );
  animation: ${(p) => (p.isLoaded ? orangeStop : orangeAnim)};
  animation: ${(p) => (p.isShaking ? isShakingOrange : null)};
  animation: ${(p) => (p.chosen === "yellow" ? choosenYellowOrange : null)};
  animation: ${(p) => (p.chosen === "orange" ? choosenOrangeOrange : null)};
  animation: ${(p) => (p.chosen === "purple" ? choosenPurpleOrange : null)};
  svg {
    ${(p) => (p.showText ? "opacity: 1" : "opacity: 0")};
    transition: all 400ms;
  }
`;
const yellowX = keyframes`
    0% {
      left: -126px;
      animation-timing-function: ease-in;
    }
    25% {
      left: -85px;
      animation-timing-function: ease-out;
    }
    50% {
      left: -45px;
      animation-timing-function: ease-in;
    }
    75% {
      left: -93px;
      animation-timing-function: ease-out;
    }
    100% {
      left: -126px;
    
  }`;
const yellowY = keyframes`
    0% {
      top: 239px;
      animation-timing-function: ease-out;
    }
    25% {
      top: 201px;
      animation-timing-function: ease-in;

    }
    50% {
      top: 239px;
      animation-timing-function: ease-out;

    }
    75% {
      top: 282px;
      animation-timing-function: ease-in;
    }
    100% {
      top: 239px;
    }
  `;
const yellowAnim = css`
  ${yellowX} 5s infinite, ${yellowY} 5s infinite;
`;
const stopY = keyframes`
    to{
        top: 52px;
        left: 110px;
        transform:scale(1.5);
        color: rgba(255, 255, 255, 1);

    }
`;
const yellowStop = css`
  ${stopY} 1s 1 forwards;
`;

const isShakingYellowAnim = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        top: 52px;
        left: 110px;
        transform:scale(1.5);
        color: rgba(255, 255, 255, 1);

      }
      
      50% { 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        top: 52px;
        left: 110px;
        transform:scale(1.35);
        color: rgba(255, 255, 255, 1);

      }
      
      100%{ 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        top: 52px;
        left: 110px;
        transform:scale(1.5);
        color: rgba(255, 255, 255, 1);

      }
  `;
const isShakingYellow = css`
  ${isShakingYellowAnim} 2s infinite forwards;
`;
const choosenOrangeAnimYellow = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        top: 52px;
        left: 110px;
        transform:scale(1.5)
         }
       100%{ 
        top: -352px;
        left: 110px;
        transform:scale(1.5)
        }
  `;
const choosenOrangeYellow = css`
  ${choosenOrangeAnimYellow} 983ms 1 forwards;
`;
const choosenYellowAnimYellow = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        left: 110px;
        top: 52px;
        transform:scale(1.5); 
        opacity: 1;
        /* color: rgba(255, 255, 255, 1); */
      }
      
      50% { 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        left: 80px;
        top: 222px;
        transform:scale(1.5);
        opacity: 1;
        /* color: rgba(255, 255, 255, 1); */
      }
      
      100% { 
        left: 80px;
        top: 222px;
        transform: scale(4.5);
        opacity: 0;
        /* color: rgba(255, 255, 255, 0); */
      }
  `;
const choosenYellowYellow = css`
  ${choosenYellowAnimYellow} 2500ms 1 forwards;
`;
export const Yellow = styled.div`
  position: absolute;
  width: 210px;
  height: 210px;
  text-align: center;
  line-height: 210px;

  border-radius: 110px;
  top: ${(p) => (p.c.yt ? p.c.yt + "px" : "255px")};
  left: ${(p) => (p.c.yl ? p.c.yl + "px" : "125px")};
  pointer-events: ${(p) => (p.isLoaded ? "auto" : "none")};

  box-shadow: inset 0 0.5px 10px 0 #feec00;
  background-image: radial-gradient(
    circle at 53% 64%,
    #ff9900,
    #ffae00 41%,
    #ffe700 113%
  );
  animation: ${(p) => (p.isLoaded ? yellowStop : yellowAnim)};
  animation: ${(p) => (p.isShaking ? isShakingYellow : null)};
  animation: ${(p) => (p.chosen === "yellow" ? choosenYellowYellow : null)};
  animation: ${(p) =>
    p.chosen === "orange" || p.chosen === "purple"
      ? choosenOrangeYellow
      : null};
  svg {
    ${(p) => (p.showText ? "opacity: 1" : "opacity: 0")};
    transition: all 400ms;
  }
`;
const whiteX = keyframes`
    0% {
      left: 246px;
      animation-timing-function: ease-in;
    }
    25% {
      left: 287px;
      animation-timing-function: ease-out;
    }
    50% {
      left: 330px;
      animation-timing-function: ease-in;
    }
    75% {
      left: 287px;
      animation-timing-function: ease-out;
    }
    100% {
      left: 246px;
    
  }`;
const whiteY = keyframes`
    0% {
      top: 330px;
      animation-timing-function: ease-out;
    }
    25% {
      top: 371px;
      animation-timing-function: ease-in;

    }
    50% {
      top: 330px;
      animation-timing-function: ease-out;

    }
    75% {
      top: 287px;
      animation-timing-function: ease-in;
    }
    100% {
      top: 330px;
    }
  `;
const whiteAnim = css`
  ${whiteX} 5s infinite, ${whiteY} 5s infinite;
`;
const stopW = keyframes`
    to{
        left: 546px;
        top: 330px;
        transform:scale(1.2)
    }
`;
const whiteStop = css`
  ${stopW} 1s 1 forwards;
`;
export const White = styled.div`
  position: absolute;
  width: 210px;
  height: 210px;
  border-radius: 105px;
  top: ${(p) => (p.c.wt ? p.c.wt + "px" : "246px")};
  left: ${(p) => (p.c.wl ? p.c.wl + "px" : "330px")};
  pointer-events: ${(p) => (p.isLoaded ? "auto" : "none")};

  box-shadow: inset 0 0.5px 10px 0 rgba(0, 0, 0, 0.5);
  background: #d5d4d3;
  animation: ${(p) => (p.isLoaded ? whiteStop : whiteAnim)};
`;
const purpleX = keyframes`
    0% {
      left: 118px;
      animation-timing-function: ease-out;
    }
    25% {
      left: 158px;
      animation-timing-function: ease-in;
    }
    50% {
      left: 118px;
      animation-timing-function: ease-out;
    }
    75% {
      left: 75px;
      animation-timing-function: ease-in;
    }
    100% {
      left: 118px;
    
  }`;
const purpleY = keyframes`
    0% {
      top:  42px;
      animation-timing-function: ease-in;
    }
    25% {
      top: -10px;
      animation-timing-function: ease-out;

    }
    50% {
      top: -50px;
      animation-timing-function: ease-in;
    }
    75% {
      top: -10px;
      animation-timing-function: ease-out;
    }
    100% {
      top:  42px;
    }
  `;
const purpleAnim = css`
  ${purpleX} 5s infinite, ${purpleY} 5s infinite;
`;
const stopP = keyframes`
    to{
        left: 143px;
        top: 436px;
        transform:scale(.97);
        color: rgba(255, 255, 255, 1);

    }
`;
const purpleStop = css`
  ${stopP} 1s 1 forwards;
`;
const isShakingPurpleAnim = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        left: 143px;
        top: 436px;
        transform:scale(.97);
        color: rgba(255, 255, 255, 1);

      }
      
      50% { 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        left: 143px;
        top: 436px;
        transform:scale(.92);
        color: rgba(255, 255, 255, 1);

      }
      
      100%{ 
        animation-timing-function: cubic-bezier(0.33, 0, 0.67, 1);
        left: 143px;
        top: 436px;
        transform:scale(.97);
        color: rgba(255, 255, 255, 1);

      }
  `;
const isShakingPurple = css`
  ${isShakingPurpleAnim} 2s infinite forwards
`;
const choosenYellowAnimPurple = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        left: 143px;
        top: 436px;
        transform:scale(.97)
         }
       100%{ 
        left: 743px;
        top: 836px;
        transform:scale(.97)
        }
  `;
const choosenYellowPurple = css`
  ${choosenYellowAnimPurple} 983ms 1 forwards;
`;
const choosenOrangeAnimPurple = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        left: 143px;
        top: 436px;
        transform:scale(.97)
         }
       100%{ 
        left: 343px;
        top: 736px;
        transform:scale(.97)
        }
  `;
const choosenOrangePurple = css`
  ${choosenOrangeAnimPurple} 983ms 1 forwards;
`;
const choosenPurpleAnimPurple = keyframes`
      0%{ 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        left: 143px;
        top: 436px;
        transform:scale(.97);
        opacity: 1;
        color: rgba(255, 255, 255, 1);

      }
      
      50% { 
        animation-timing-function: cubic-bezier(0.35, 0, 0, 1);
        left: 80px;
        top: 222px;
        transform:scale(.97);
        opacity: 1;
        color: rgba(255, 255, 255, 1);
      }
      
      100% { 
        left: 80px;
        top: 222px;
        transform: scale(9);
        opacity: 0;
        color: rgba(255, 255, 255, 0);
       }
  `;
const choosenPurplePurple = css`
  ${choosenPurpleAnimPurple} 2500ms 1 forwards;
`;
export const Purple = styled.div`
  position: absolute;
  width: 233px;
  height: 233px;
  text-align: center;
  line-height: 233px;
  color: rgba(255, 255, 255, 0);

  top: ${(p) => (p.c.pt ? p.c.pt + "px" : "118px")};
  left: ${(p) => (p.c.pl ? p.c.pl + "px" : "42px")};
  pointer-events: ${(p) => (p.isLoaded ? "auto" : "none")};
  border-radius: 122px;
  box-shadow: inset 0 0.5px 10px 0 rgba(0, 0, 0, 0.5);
  background-image: radial-gradient(
    circle at 50% 27%,
    #6a258b,
    #440e63 57%,
    #2c004b 87%
  );
  animation: ${(p) => (p.isLoaded ? purpleStop : purpleAnim)};
  animation: ${(p) => (p.isShakingPurple ? isShakingPurple : null)};
  animation: ${(p) => (p.chosen === "yellow" ? choosenYellowPurple : null)};
  animation: ${(p) => (p.chosen === "orange" ? choosenOrangePurple : null)};
  animation: ${(p) => (p.chosen === "purple" ? choosenPurplePurple : null)};
  svg {
    ${(p) => (p.showText ? "opacity: 1" : "opacity: 0")};
    transition: all 400ms;
  }
`;
